module.exports = __webpack_public_path__ + "svg/close-white.svg?e1959dcf6feb42397102058302503ffc";